import 'react-dates/initialize';
import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router';
import Alert from 'react-s-alert';


import SocketManager from '../modules/SocketManager.js';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setGlobalKey} from '../actions/General.js';

window.crall_audio = {};
window.crall_audio.message_pling = new Audio('/pling.mp3');


class App extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        SocketManager.start();

        window.onfocus = () => {
            this.props.setGlobalKey('windowHasFocus', true);
        }
        window.onblur = () => {
            this.props.setGlobalKey('windowHasFocus', false);
        }

        this.props.setGlobalKey('windowHasFocus', document.hasFocus());
    }

    componentDidUpdate() {
        SocketManager.start();
    }



    render() {
        return (
            <div className="root" style={{height: '100%'}}>
                <Alert stack={{limit: 3}} />
                {this.props.children}
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        general: state.general,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setGlobalKey}, dispatch)
}

App = connect(mapStateToProps, mapDispatchToProps)(App);

export default App;



// WEBPACK FOOTER //
// ./containers/App.js